import { render } from "./dataSync.vue?vue&type=template&id=318ce09e&scoped=true"
import script from "./dataSync.vue?vue&type=script&lang=js"
export * from "./dataSync.vue?vue&type=script&lang=js"

import "./dataSync.vue?vue&type=style&index=0&id=318ce09e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318ce09e"]])

export default __exports__